import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Form, Loading } from 'components';

class CustomForm extends Component {
  static defaultProps = {
    edit: false,
  };

  state = {
    data: this.props.data,
  };

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { loading, onChange } = this.props;

    if (oldProps.loading && !loading && oldProps.data !== this.props.data) {
      this.setState({ data: { ...this.props.data } });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = e => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { onSave } = this.props;

    onSave();
  };

  render() {
    const { data } = this.state;
    const { errors, saving } = this.props;

    return (
      <Form className="page-form" onSubmit={this.handleSubmit}>
        <h3 className="form-title">Detalhes da Razão</h3>

        <Form.Field>
          <Form.Label>Título</Form.Label>
          <Form.Input
            name="title"
            placeholder="Título da razão"
            value={data.title}
            onChange={this.handleChangeInput}
            errors={errors.title}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.TextArea
            name="description"
            placeholder="Descrição da razão"
            value={data.description}
            onChange={this.handleChangeInput}
            errors={errors.description}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Alias</Form.Label>
          <Form.Input
            name="alias"
            placeholder="Alias da razão"
            value={data.alias}
            onChange={this.handleChangeInput}
            errors={errors.alias}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/reasons/list" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button className="button-save" onClick={this.handleSubmit} disabled={saving}>
            {saving ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

export default CustomForm
